var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-form-controlled';

var Alert = function (_Element) {
  _inherits(Alert, _Element);

  function Alert() {
    _classCallCheck(this, Alert);

    return _possibleConstructorReturn(this, _Element.apply(this, arguments));
  }

  Alert.prototype.componentDidMount = function componentDidMount() {
    var form = this.getForm();
    form.registerChild(this);
  };

  Alert.prototype.componentWillUnmount = function componentWillUnmount() {
    var form = this.getForm();
    form.unregisterChild(this);
  };

  Alert.prototype.originalValueChanged = function originalValueChanged() {
    this.forceUpdate();
  };

  Alert.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        render = _props.render,
        Component = _props.component,
        exact = _props.exact,
        rest = _objectWithoutProperties(_props, ['className', 'children', 'render', 'component', 'exact']);

    var path = this.getPath();
    var form = this.getForm();

    var errors = form.getErrors(path, exact);
    if (!errors || !errors.length) {
      return null;
    }

    if (typeof children === 'function') {
      return this.replaceChildren(children({ errors: errors }));
    } else if (typeof render === 'function') {
      return this.replaceChildren(render({ errors: errors }));
    } else if (Component) {
      return React.createElement(Component, _extends({ errors: errors }, rest));
    } else if (children) {
      return children;
    }

    return React.createElement(
      'div',
      { role: 'alert', className: className },
      errors.map(function (error) {
        return error.message;
      })
    );
  };

  return Alert;
}(Element);

Alert.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  exact: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  render: PropTypes.func,
  component: PropTypes.node,
  className: PropTypes.string
};
export default Alert;
//# sourceMappingURL=Alert.js.map